// In local dev, the frontend and backend share an origin via Vite's dev
// proxy, so this is '' and every request stays relative. In production,
// the frontend (Cloudflare Pages) and backend (Fly.io) live on different
// domains, so VITE_API_URL must be set at build time to the backend's URL.
export const API_BASE = import.meta.env.VITE_API_URL || '';

// Cross-origin requests don't send cookies unless explicitly told to —
// credentials: 'include' is what lets the session cookie (Kick login) reach
// the backend when the two are on different domains. Harmless same-origin too.
export function apiFetch(path, opts) {
  return fetch(`${API_BASE}${path}`, { credentials: 'include', ...opts });
}

// For plain URL construction (login redirect, socket.io) where fetch() isn't involved.
export function apiUrl(path) {
  return `${API_BASE}${path}`;
}

// image_url/avatar_url values from the API are sometimes a backend-relative
// path (e.g. uploaded store/case/raffle images live at /uploads/...) and
// sometimes already an absolute URL (Kick's CDN for avatars). Only relative
// ones need the backend's domain prefixed on — absolute ones pass through.
export function mediaUrl(path) {
  if (!path) return path;
  return /^https?:\/\//i.test(path) ? path : `${API_BASE}${path}`;
}
